//
// Copyright 2022 Avvia Life, All Rights Reserved
//

import {
  useCallback,
} from "react"

import {
  useLocation,
} from 'react-router-dom'

import feathersClient from '../feathersClient/feathersClient'

const {
  NotAuthenticated,
 } = require('@feathersjs/errors');

const {
  useReLogin,
  setLoginPath,
  useAuth,
 } = require('./ALAuth');

//

function useALService() {
  const returnpath = useLocation().pathname
  const reLogin = useReLogin()
  const isAuth = useAuth()

  const service = useCallback( async ( service, method, ...args ) => {
    try {
      if( method !== 'authenticate' ) setLoginPath( returnpath )
      return await feathersClient.service(service)[method]( ...args )
    }
    catch ( e ) {
      // TODO set 'Login timed out' message for ALSignIn to show
      if( e instanceof NotAuthenticated ) { if( isAuth ) { reLogin() } }
      else throw e
    }
  }, [ reLogin, returnpath, isAuth ] )
  return service
}

export {
  useALService,
}